export const isPDF = (string) => {
    if (!string) return false;

    try {
        const { pathname } = new URL(string);
        return pathname.toLowerCase().endsWith('.pdf');
    } catch (error) {
        return false;
    }
};
